/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Integrations_G_SalesInputs */

const tr_landing_integrations_g_sales = /** @type {(inputs: Landing_Integrations_G_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satış kanalları`)
};

const en_landing_integrations_g_sales = /** @type {(inputs: Landing_Integrations_G_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sales channels`)
};

const de_landing_integrations_g_sales = /** @type {(inputs: Landing_Integrations_G_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verkaufskanäle`)
};

const ru_landing_integrations_g_sales = /** @type {(inputs: Landing_Integrations_G_SalesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Каналы продаж`)
};

/**
* | output |
* | --- |
* | "Sales channels" |
*
* @param {Landing_Integrations_G_SalesInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_integrations_g_sales = /** @type {((inputs?: Landing_Integrations_G_SalesInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Integrations_G_SalesInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_integrations_g_sales(inputs)
	if (locale === "de") return de_landing_integrations_g_sales(inputs)
	if (locale === "ru") return ru_landing_integrations_g_sales(inputs)
	return tr_landing_integrations_g_sales(inputs)
});